<script>
  import { onMount } from 'svelte'
  import { Toaster, toast } from 'svelte-sonner';
  import { page } from '@inertiajs/svelte'
  import ConfirmEmailMessage from '@components/general/confirm-email-message.svelte'
  import Navigation from '@components/layout/navigation.svelte'
  import { appState } from '@state/app-state.svelte.js'
  import { cn } from '@lib/utils'
  import CookieConsentBanner from '@components/general/cookie-consent-banner.svelte'

  let { children } = $props();

  $effect(() => {
    appState.user = $page.props.user
  })

  let lastFlash = $state(null)

  $effect(() => {
    const flash = $page.props.flash
    const key = JSON.stringify(flash)
    if (key === lastFlash) return
    lastFlash = key
    if (flash.notice) toast.info(flash.notice)
    if (flash.success) toast.success(flash.success)
    if (flash.alert) toast.error(flash.alert)
  })

  let user = $page.props.user
  let unconfirmed = $derived(user && !user.is_admin && !user.confirmed)

  function handleKeydown(event) {
    const inputFocused = ["input", "select", "textarea"].includes(document.activeElement.tagName.toLowerCase()) || document.activeElement.isContentEditable
    
    // Meta + B toggles the sidebar
    if ((event.metaKey || event.ctrlKey) && event.key === "b" && !inputFocused) appState.sidebarOpen = !appState.sidebarOpen
  }

  function setSidebarState() {
    const pageWidth = document.documentElement.clientWidth
    if (pageWidth < 1400) appState.sidebarOpen = false
  } 

  onMount(() => {
    setSidebarState()
  })
</script>

<svelte:window onkeydown={handleKeydown} />

{#if unconfirmed}
  <ConfirmEmailMessage />
{/if}

<div class={cn("flex flex-col lg:flex-row h-screen overflow-hidden bg-stone-50 border-t-4 border-brand-blue", unconfirmed ? 'border-none' : '')}>
  <Navigation />
  <div scroll-region class={cn("flex-1 min-h-0 overflow-y-auto px-3 py-6", appState.sidebarOpen ? "" : "lg:pl-0")}>{@render children?.()}</div>
</div>

<Toaster position="top-right" closeButton expand />
<CookieConsentBanner />
